/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
import {
    Breadcrumb, Button,
} from 'appkit-react';
import {
    Row, Col, Card, Container,
} from 'react-bootstrap';

import Loader from 'views/Shared/components/Loader';
import ErrorView from 'views/Shared/components/ErrorView';
import QualityChart from './QualityChart';
import DataQualityTable from './DataQualityTable';
import RuleModalContainer from '../containers/RuleModalContainer';
import '../styles/qualityDashboard.scss';

const DataQuality = ({
    breadcrumbItems, navigateBack, dataQualityStatusColumns,
    navigateToDetails, summaryData, dataLoading, rulesRunData,
    showAddRuleModal, setShowAddRuleModal, params, isError,
    setIsAssignedRulesSaved,
}) => {
    if (dataLoading) {
        return <Loader />;
    }
    if (isError) {
        return <ErrorView />;
    }

    const customStyle = { width: 'content-fit', marginLeft: '0.5rem', marginRight: '0.5rem' };

    return (
        <div className="true-comply-data-quality-dashboard_layout">
            <div className="true-comply-data-quality-dashboard_column-2">
                <Breadcrumb items={breadcrumbItems} />
                <Row>
                    <Col>
                        <div className="a-h3 title-label">
                            <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={navigateBack} role="presentation" />
                            <span>DQS Dashboard - </span>
                            <span style={{ fontWeight: 'normal', fontSize: '22px' }}>{params.fileDisplayName}</span>
                        </div>
                    </Col>
                    <Col>
                        <span
                            style={{ float: 'right', marginRight: '0.5rem' }}
                        >
                            <Button
                                className="a-btn a-btn-secondary a-btn-lg"
                                kind="secondary"
                                size="lg"
                                onClick={() => setShowAddRuleModal(true)}
                            >
                                DATA QUALITY RULE ADMIN
                            </Button>
                        </span>
                    </Col>
                </Row>
                {showAddRuleModal
                    && (
                        <RuleModalContainer
                            showAddRuleModal={showAddRuleModal}
                            setShowAddRuleModal={setShowAddRuleModal}
                            params={params}
                            setIsAssignedRulesSaved={setIsAssignedRulesSaved}
                        />
                    )}
                <Container
                    fluid
                    className="true-comply-data-quality-dashboard_card_container"
                >
                    <Row
                        className="g-4"
                        md={3}
                        style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.5rem' }}
                    >
                        <Col
                            className="true-comply-data-quality-dashboard_card_row_1_col"
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                            <Card
                                className="mb-2"
                                style={customStyle}
                            >
                                <Card.Body>
                                    <Card.Title> Overall DQ Score </Card.Title>
                                    <Card.Text>
                                        {(summaryData && summaryData.overallDQScore)}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col
                            className="true-comply-data-quality-dashboard_card_row_1_col"
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                            <Card
                                className="mb-2"
                                style={customStyle}
                            >
                                <Card.Body>
                                    <Card.Title> Total rows processed </Card.Title>
                                    <Card.Text>
                                        {(summaryData && summaryData.totalRowsProcessed)}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col
                            className="true-comply-data-quality-dashboard_card_row_1_col"
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                            <Card
                                className="mb-2"
                                style={customStyle}
                            >
                                <Card.Body>
                                    <Card.Title> Failed Rows </Card.Title>
                                    <Card.Text>
                                        {(summaryData && summaryData.totalFailedRows)}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {summaryData.dimScore.length > 0 && (
                        <Row
                            md={6}
                            className="g-4"
                            style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.5rem' }}
                        >
                            {summaryData.dimScore.map((_, idx) => (
                                <Col
                                    className="true-comply-data-quality-dashboard_card_row_2_col"
                                    key={`card_${idx}`}
                                >
                                    <Card onClick={() => navigateToDetails(_)}>
                                        <Card.Body>
                                            <Card.Title>{`${_.title.charAt(0).toUpperCase() + _.title.slice(1)}`}</Card.Title>
                                            <div>
                                                <QualityChart
                                                    qualityMatchPercentage={_.value}
                                                    index={idx}
                                                />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )}
                    <Row
                        className="g-4"
                        style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.5rem' }}
                    >
                        <Col>
                            <DataQualityTable
                                dataQualityStatusColumns={dataQualityStatusColumns}
                                ruleSummaryData={rulesRunData}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default DataQuality;
